<template>
    <div class="relative">
        <label class="form-input" :for="name">
            <span>{{ label }} <span v-if="required" :class="{'text-red' : !contrast }">*</span></span>
            <input type="text"
                   @input="onChange"
                   autocomplete="off"
                   :id="name"
                   :name="name"
                   :required="required"
                   v-model="search"
                   @keyup.down="onArrowDown"
                   @keyup.up="onArrowUp"
                   @keyup.enter.stop="onEnter"
                   @focus="onChange"/>
            <icon name="chevron"
                  :class="[isOpen ? 'rotate-180' : 'rotate-0']"
                  class="absolute right-4 bottom-4 w-4 h-4 transform fill-current transition-transform" />
            <span class="form-error" :class="{ '!text-white' : contrast }">{{ requiredLabel }}</span>
        </label>
        <div v-show="isOpen"
             class="absolute z-10 top-19 mt-1.5 w-full rounded-md shadow-lg overflow-hidden bg-white text-gray border-2 border-light-gray ">
            <ul class="bg-white max-h-48 overflow-auto p-1.5">
                <li v-for="(result, i) in results"
                    :key="i"
                    @click="setResult(result)"
                    class="transition-colors cursor-pointer hover:bg-light-gray bg-opacity-50 hover:text-black rounded-md p-3"
                    :class="{ 'text-red': i === arrowCounter }">
                    {{ result }}
                </li>
            </ul>
        </div>

    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class AutocompleteInput extends Vue {
    @Prop({ required: true }) items: string[];
    @Prop({ required: true }) name: string;
    @Prop({ required: true }) label: string;
    @Prop({ default: false, type: Boolean }) required: boolean;
    @Prop({ default: false, type: Boolean }) contrast: boolean;
    @Prop({ default: '', type: String}) requiredLabel: string

    isOpen = false;
    results = [];
    search = '';
    arrowCounter = 0;

    mounted(): void {
        document.addEventListener('click', this.handleClickOutside);
    }

    destroyed(): void {
        document.removeEventListener('click', this.handleClickOutside);
    }

    onChange(): void {
        this.$emit('input', this.search);
        this.filterResults();
        this.isOpen = true;
    }

    filterResults(): void {
        this.results = this.items.filter(item => {
            const regex = new RegExp(`(^|\\s)(${this.search.toLowerCase()})`);
            return item.toLowerCase().match(regex);
            // return item.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        });
    }

    setResult(result: string): void {
        this.search = result;
        this.isOpen = false;
    }

    onArrowDown(): void {
        if (this.arrowCounter < this.results.length) {
            this.arrowCounter = this.arrowCounter + 1;
        }
    }

    onArrowUp(): void {
        if (this.arrowCounter > 0) {
            this.arrowCounter = this.arrowCounter - 1;
        }
    }

    onEnter(): void {
        this.search = this.results[this.arrowCounter];
        this.isOpen = false;
        this.arrowCounter = -1;
    }

    handleClickOutside(evt: any): void {
        if (!this.$el.contains(evt.target)) {
            this.isOpen = false;
            this.arrowCounter = -1;
        }
    }

    @Watch('items')
    onItemsCHanged(val: string[], oldValue: string[]): void {
        if (val.length !== oldValue.length) {
            this.results = val;
        }
    }
}
</script>
